module.exports = __webpack_public_path__ + "static/media/keyboard_return.68098c3f.svg";